import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose, withProps } from 'recompose'
import {
  deleteSection,
  moveSection,
  editSectionColor,
  duplicateSection,
  createSection
} from '../../../../store/actions/sections'
import {
  sectionLayoutAdjustedSelector,
  orderedSectionsSelector
} from '../../../../store/selectors/boardSelectors'
import { withTranslation } from 'react-i18next'

const SectionOptionsContainer = compose(
  connect(
    (state, { sectionId }) => ({
      section: sectionLayoutAdjustedSelector(state).get(sectionId),
      sectionCount: orderedSectionsSelector(state).length
    }),
    {
      moveSection,
      editSectionColor,
      createSection,
      deleteSection,
      duplicateSection
    },
    (stateProps, dispatchProps, ownProps) => ({
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      createSection: number => {
        ownProps.hide()
        dispatchProps.createSection(stateProps.section.board, number)
        ownProps.scrollToSection(number)
      },
      moveSection: newNumber => {
        ownProps.hide()
        dispatchProps.moveSection(stateProps.section, newNumber)
      },
      editSectionColor: color =>
        dispatchProps.editSectionColor(stateProps.section, color),
      duplicateSection: () => {
        ownProps.hide()
        dispatchProps.duplicateSection(stateProps.section)
      },
      deleteSection: () => dispatchProps.deleteSection(stateProps.section)
    })
  ),
  withProps(({ section }) => ({
    sectionNumber: section.number,
    sectionColor: section.color || 'white'
  })),
  withTranslation()
)

SectionOptionsContainer.propTypes = {
  sectionId: PropTypes.string.isRequired,
  handleClickOutside: PropTypes.func.isRequired
}

export default SectionOptionsContainer
